import useSpendDataSchema from '/business/shared/components/questions/scope3/goods/shared/_hooks/useSpendDataSchema';
import type { QuestionSchemaType } from '/index';

export default function useGetPurchasedGoodsSpendDataSchema(): QuestionSchemaType {
  return useSpendDataSchema({ question: 'purchasedGoods' });
}
